<template>
  <div>
    <template v-if="isStandardTask">
      <div class="standardTaskBox">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 搜索框 -->
        <div class="searchCon">
          <div class="searchMain">
            <ots-refer
                :selectList="selectList"
                :request-form="selectForm"
                @search="getResult"
            />
          </div>
        </div>
        <!-- 列表 -->
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableData="tableData"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>

        <ots-custom-dialog :dialog.sync="reconversionDialog" title="重新转换" width="500px">
          <template v-slot:content>
            <div style="margin-bottom: 10px;"><i class="el-icon-warning" style="color: red; font-size: 17px;"></i>&nbsp;确认对该任务重新检测吗？</div>
            <el-input
                type="textarea"
                :rows="5"
                placeholder="如果对转换结果不满意，可以在此输入个性化需求来影响检测结果，如果不输入则使用默认规则重新检测"
                v-model="addComment">
            </el-input>
          </template>
          <template v-slot:footer>
            <el-button round type="primary" @click="reconversionDialog = false" plain>取消</el-button>
            <el-button round type="primary" @click="reStartTask">确定</el-button>
          </template>
        </ots-custom-dialog>

      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
<script>
import {
    taskListFn,
    taskChangeDeleteFn,
    taskChangeWaitFn,
    taskChangeWaitAgainFn,
    taskDownloadQuestionFn,
    taskDownloadOriFileFn,
} from '@/http/modules/baseSet/standardTask'
import { getSelectCourse } from "@/http/modules/baseSet/course";

export default {
  name: 'standardTask',
  data() {
    return {
      reconversionDialog: false,
      nowTaskId: '',
      addComment: '',
      mainTopBtnList: [
        {
          title: "新增",
          fn: this.goAddPage,
        },
      ],
      selectList: [
        {
          title: "课程名称",
          type: "select",
          requestKey: "courseId",
          label: 'name',
          value: 'id',
          isSearch: true,
          data: [{ name: "全部",id: "", }],
        },
        {
          title: "转换状态",
          type: "select",
          requestKey: "changeState",
          label: "name",
          value: "id",
          data: [
            { name: "全部",id: "", },
            { name: "等待转换",id: 0, },
            { name: "队列中",id: 1, },
            { name: "进行中",id: 2, },
            { name: "转换成功",id: 3, },
            { name: "转换失败",id: 4, },
          ],
        },
        {
          title: "转换时间",
          type: "daterange",
          requestKey: "dateRange",
          pickerOptions: {
            shortcuts: [
              {
                text: "今天",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  picker.$emit("pick", [start, end]);
                },
              },
              {
                text: "昨天",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24);
                  picker.$emit("pick", [start, end]);
                },
              },
              {
                text: "最近一周",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit("pick", [start, end]);
                },
              },
            ],
          },
        },
      ],
      selectForm: {
        courseId: '',
        changeState: '',
        dateRange: [],
        taskFinishDateL: '',
        taskFinishDateR: '',
      },
      tableHeader: [
        {
          prop: 'orderId',
          title: '序号',
          width: '80',
        },
        {
          prop: 'courseName',
          title: '课程名称',
          width: '200',
        },
        {
          prop: 'standardTaskFileName',
          title: '文件名称',
          type: "button",
          click: this.downloadOriginalFile,
        },
        {
          prop: 'changeStateName',
          title: '转换状态',
          type: "textAndButton",
          btnText: this.getBtnText,
          click: this.downloadFile,
        },
        {
          prop: 'createDate',
          title: '任务创建时间',
          width: '170',
        },
        {
          prop: 'taskFinishDate',
          title: '转换时间',
          width: '170',
        },
        {
          title: "操作",
          type: "buttons",
          width: "240",
          btnList: [
            {
              title: "开始转换",
              click: this.startTask,
              disableFn: (val) => val.row.changeState == 0 ? false : true,
            },
            {
              title: "重新转换",
              click: this.reconversionDialogFn,
              disableFn: (val) => ![3, 4].includes(val.row.changeState),
            },
            {
              title: "删除",
              disableFn: (val) => ![0, 1].includes(val.row.changeState),
              click: this.deleteTask,
            },
            {
              title: "题目入库",
              disableFn: (val) => ![3].includes(val.row.changeState),
              click: this.goFormat,
            },
          ],
        },
      ],
      tableData: [],
      pagination: {
        total: 0,
        page: 1,
        size: 10,
      },
    }
  },
  created() {
    this.initData();
    this.getResult();
  },
  computed: {
    isStandardTask() {
      return this.$route.name === "standardTask";
    },
  },
  methods: {
    initData() {
      getSelectCourse().then(({ data }) => {
        this.$set(this.selectList[0], "data", [{ name: "全部",id: "", }].concat(data));
      })
    },
    // 获取列表
    getResult() {
      let params = {
        ...this.selectForm,
        ...this.pagination,
      };
      delete params.dateRange;
      delete params.total;
      taskListFn(params).then((res) => {
        if (res.code === 1) {
          if(res.data.records){
            this.tableData = res.data.records.map((item,index) => {
                item.orderId = index + 1;
                return item;
            });
            this.pagination.page = res.data.current;
            this.pagination.total = res.data.total;
          }
        }
      })
    },
    // 改变每页显示条数
    changeSize(num) {
      this.pagination.size = num;
      this.getResult();
    },
    // 改变当前页
    changePage(num) {
      this.pagination.page = num;
      this.getResult();
    },
    startTask(row){
      taskChangeWaitFn({ taskId: row.id }).then((res) => {
        if (res.code == 1) {
            this.$message.success(res.data);
            this.getResult();
        }
      })
    },
    reconversionDialogFn(row){
      this.nowTaskId = row.id;
      this.reconversionDialog = true;
    },
    reStartTask(row){
      // this.$confirm("确认要重新转换该任务吗?", "提示", {
      //   type: "warning",
      // })
      // .then(() => {
        let params = {
          taskId: this.nowTaskId,
          addComment : this.addComment,
        }
        taskChangeWaitAgainFn(params).then((res) => {
          if (res.code == 1) {
              this.$message.success(res.data);
              this.getResult();
              this.reconversionDialog = false;
          }
        });
      // })
      // .catch(() => {});
    },
    deleteTask(row){
      this.$confirm("确认要删除该任务吗?", "提示", {
        type: "warning",
      })
      .then(() => {
        taskChangeDeleteFn({ taskId: row.id }).then((res) => {
        if (res.code == 1) {
            this.$message.success("删除任务成功");
            this.getResult();
        }
        });
      })
      .catch(() => {});
    },
    goFormat(row) {
      this.$router.push({
        name: "standardFormat",
        query: {
          taskId : row.id,
          courseId: row.courseId,
          courseName: row.courseName,
        },
      });
    },
    goAddPage() {
      this.$router.push({
        name: "standardTaskAdd",
      });
    },
    getBtnText(row) {
      return row.changeState == 3 ? "下载" : "";
    },
    async downloadOriginalFile(row){
      const res = await taskDownloadOriFileFn({ taskId: row.id });
      if (res.code === 1) {
        const link = document.createElement('a');
        link.href = res.data;
        link.download = row.standardTaskFileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    async downloadFile(row){
      await taskDownloadQuestionFn({ taskId: row.id }).then((res) => {
          if (res.code == 1) {
            window.open(res.data);
          }
        }
      );
    },
  },
  watch: {
    "selectForm.dateRange"(val) {
      if (val && val.length) {
        this.selectForm.taskFinishDateL = val[0];
        this.selectForm.taskFinishDateR = val[1];
      } else {
        this.selectForm.taskFinishDateL = "";
        this.selectForm.taskFinishDateR = "";
      }
    },
    "$route.name"(val) {
      if (val === "standardTask") {
        this.getResult();
      }
    }
  },
}

</script>
<style lang="less" scoped>
.standardTaskBox {
  .searchCon {
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    .searchMain {
      flex: 1;
    }
    .searchBtn {
      flex-shrink: 0;
      width: 72px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .mainCon {
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
  }
}
.el-range-input{ width: 500px !important;}
</style>